import React from "react";
import { TableRow, Checkbox, TableCell, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { amountFormat } from "../../../util/constants";
import moment from "moment";
import "./footer.css";
import CustomCheckbox from "../../customCheckbox";

const useStyles = makeStyles({
  customTable: {
    "& .MuiTableCell-alignLeft": {
      padding: "22px 0px 22px 0px",
    },
  },
});

export const TransactionRow = ({
  isItemSelected,
  selectionKey,
  handleClick,
  row,
  openActionMenu,
  actionButtonClass,
  labelId,
}) => {
  const classes = useStyles();

  return (
    <>
      {
        <TableRow
          hover
          style={{
            borderBottom: "1px solid #636365",
            backgroundColor: isItemSelected ? "#FAF9F6" : "white",
          }}
          role="checkbox"
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={row.name}
          selected={isItemSelected}
          classes={{ root: classes.customTable }}
        >
          <TableCell padding="checkbox">
            <CustomCheckbox
              onClick={(event) => handleClick(event, row[selectionKey])}
              checked={isItemSelected}
              inputProps={{ "aria-labelledby": labelId }}
            />
          </TableCell>
          <TableCell align="left" style={{ fontWeight: 500 }}>
            {row?.payeeType === "STUDENT"
              ? row?.studentRegNo
              : row?.parentRegNo}
          </TableCell>
          <TableCell
            align="left"
            style={{
              textTransform: "capitalize",
              fontWeight: 500,
            }}
          >{`${row?.firstName} ${row?.lastName}`}</TableCell>
          <TableCell align="left" style={{ fontWeight: 500 }}>
            {row?.createdAt
              ? moment(row.createdAt).format("YYYY-MM-DD")
              : "N/A"}
          </TableCell>
          <TableCell align="left" style={{ fontWeight: 500 }}>
            {amountFormat(row?.amount)}
          </TableCell>

          <TableCell align="left" style={{ fontWeight: 500 }}>
            {row?.bankOrderID}
          </TableCell>
          <TableCell align="left">
            <div
              role="presentation"
              onClick={(e) => {
                openActionMenu(e, row);
              }}
              className={actionButtonClass}
            >
              <MoreHorizIcon style={{ color: "gray" }} />
            </div>
          </TableCell>
        </TableRow>
      }
    </>
  );
};
